<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;admin.ms_dial_plan_exception.edit.about_card' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    @if (!isLoading) {
      <div>
        <ziro-microsoft-dial-plan-management-exception-edit-form
          [isNewGroup]="!groupId"
          [entity]="exceptionGroup"
          [groupId]="groupId"
          [exceptionGroups]="exceptionGroups"
          (ziroFormsUpdate$)="onFormUpdate($event)"
          (isValidFromDynamicValidator)="onValidationFromDynamicValidator($event)"
        ></ziro-microsoft-dial-plan-management-exception-edit-form>
      </div>
    }
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
